import { useIsomorphicLayoutEffect } from '@react-hookz/web';

import { useSession } from '~hooks/useSession';
import { liveopsApi } from '~services/api/liveops';

export const useGetPromoEventData = () => {
	const { userId } = useSession();
	const { data, isLoading, isSuccess, isError, isFetching, refetch } =
		liveopsApi.useGetPromoEventsQuery({ userId }, { skip: !userId });

	const isResolved = !isLoading && (isSuccess || isError);

	useIsomorphicLayoutEffect(() => {
		if (data?.endDate) {
			const endDate = new Date(data.endDate);
			const now = new Date();

			if (endDate < now && !isFetching) {
				void refetch();
			}
		}
	}, [data, isFetching, refetch]);

	return {
		data,
		isResolved,
		isSuccess,
	};
};
